import React from "react";
import Footer from "../../Footer/Footer";
import Navigation from "../../Navigation/Navigation";
import About from "../About/About";
import Banner from "../Banner/Banner";
import Contact from "../Contact/Contact";
import Projects from "../Projects/Projects";
import Skills from "../Skills/Skills";
import { Box } from "@mui/material";

const Home = () => {
  return (
    <Box style={{ backgroundColor: "#111a28", color: "#fff" }}>
      <Navigation></Navigation>
      <Banner></Banner>
      <About></About>
      <Skills></Skills>
      <Projects></Projects>
      <Contact></Contact>
      <Footer></Footer>
    </Box>
  );
};

export default Home;
